import { AsyncPipe, NgClass } from '@angular/common'
import { ChangeDetectionStrategy, Component, EventEmitter, inject, Output } from '@angular/core'

import { TranslatePipe } from '@ngx-translate/core'
import { Button } from 'primeng/button'
import { Tag } from 'primeng/tag'

import { Action, Resource } from '@ti/contracts'
import { CheckAccessDirective } from '@ti/core/common/directives'
import { selectState } from '@ti/core/common/utils'
import { OrderByData } from '@ti/core/contracts/data-grid'
import { FileSearchIconComponent } from '@ti/core/icons/file-search'
import { FleetIconComponent } from '@ti/core/icons/fleet'
import { NoSearchIconComponent } from '@ti/core/icons/no-search'
import { DataGridComponent } from '@ti/core/ui-kit/layout/components/data-grid'
import { YesBadgeComponent } from '@ti/core/ui-kit/layout/components/yes-badge'

import { provideAdminTspUsersModel } from '../../../tsp-users/models/users.model'
import {
  AdminTspUserManager,
  provideAdminTspUserManager,
} from '../../../tsp-users/services/user.manager'
import { AccountsModel } from '../../models/accounts.model'
import { TspGridView } from '../../models/accounts.model'

@Component({
  selector: 'app-ti-accounts-grid',
  templateUrl: 'accounts-grid.component.html',
  styleUrls: ['accounts-grid.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  providers: [provideAdminTspUsersModel(), provideAdminTspUserManager()],
  imports: [
    DataGridComponent,
    NgClass,
    AsyncPipe,
    TranslatePipe,
    NoSearchIconComponent,
    FileSearchIconComponent,
    FleetIconComponent,
    Tag,
    YesBadgeComponent,
    Button,
    CheckAccessDirective,
  ],
})
export class AccountsGridComponent {
  @Output() readonly edit = new EventEmitter<TspGridView>()
  @Output() readonly delete = new EventEmitter<TspGridView>()
  @Output() readonly rowClicked = new EventEmitter<TspGridView>()

  protected readonly model = inject(AccountsModel)
  protected readonly state = selectState(AccountsModel)
  protected readonly userManager: AdminTspUserManager = inject(AdminTspUserManager)
  protected readonly Resource = Resource
  protected readonly Action = Action

  protected onSortUpdated(event: OrderByData) {
    this.model.setOrder(event)
  }

  protected onLoadMoreClicked() {
    this.model.loadNextPage()
  }
}
